export const whatsUp = {
	title: "¿Qué hay de bueno?",
	description: `Llene los datos y comparta su evento con sus clientes a través de la aplicación
	ZIGPAY. Permita que los usuarios tengan acceso al horario de funcionamiento, redes
	sociales, fotos y enlaces externos.`,
	publish: "Publicar",
	edit: "Editar información",
	placePublishObs:
		"Al publicar usted estará aceptando mostrar la información de su local en la aplicación ZIG y ser responsable por el contenido publicado.",
	eventPublishObs:
		"Al publicar usted estará aceptando mostrar la información de su evento en la aplicación ZIG y ser responsable por el contenido publicado.",
	active: {
		titlePlace: "Mostrar local en la aplicación del usuario",
		titleEvent: "Mostrar evento en la aplicación del usuario",
		description:
			"No se cobrará ninguna tarifa extra para mostrar su local en la aplicación ZIG",
		unfilledFields: "No fue posible activar. Campos obligatorios no llenados.",
	},
	inactive: {
		placeTitle:
			"Su local no se está mostrando en la aplicación. Es necesario habilitar la visualización.",
		eventTitle:
			"Su evento no se está mostrando en la aplicación. Es necesario habilitar la visualización.",
	},
	profileSection: {
		title: "Perfil",
		seePreview: "Ver vista previa de la aplicación",
		description:
			"Puede subir imágenes de hasta 500kb en los formatos .png, .jpg o .jpeg de acuerdo con las dimensiones mencionadas abajo:",
		brandImage: "Imagen de la marca",
		brandImageObs: "Imagen cuadrada o 500x500 píxeles",
		frontCoverImage: "Imagen de portada",
		galleryImage: "Imagen para galería (opcional)",
		horizontalImageObs: "Imagen horizontal o 1280x780 píxeles",
	},
	aboutSection: {
		titlePlace: "Sobre el local",
		titleEvent: "Sobre el evento",
		descriptionPlace:
			"En esta etapa deberá llenar información sobre el local. Trate de llenar toda la información de forma clara y simple.",
		descriptionEvent:
			"En esta etapa deberá llenar información sobre el evento. Trate de llenar toda la información de forma clara y simple.",
		eventTagLimit:
			"Puede seleccionar hasta 6 tags. Las tags ayudarán a los usuarios a saber más sobre los diferenciales de su evento.",
		placeTagLimit:
			"Puede seleccionar hasta 6 tags. Las tags ayudarán a los usuarios a saber más sobre los diferenciales de su local.",
		placeName: "Nombre del local",
		eventName: "Nombre del evento",
		placeCategory: "Categoría del Local",
		eventCategory: "Categoría del evento",
		descriptionInput: "Descripción (opcional)",
		placeDescriptionPlaceHolder: "Escriba una breve descripción sobre el local",
		eventDescriptionPlaceHolder: "Escriba una breve descripción sobre el evento",
		tags: "Tags",
		musicTags: "Estilo musical",
		musicTagLimit:
			"Utilice las tags de estilo para ayudar en la visualización de su local/evento para usuarios con interés en los mismos estilos.",
		musicTagPlaceholder: "Seleccione hasta 3 estilos musicales",
		tagsPlaceholder: "Seleccione hasta 6 tags",
		barAndRestaurant: "Bar y restaurante",
		bar: "Bar",
		pub: "Pub",
		restaurant: "Restaurante",
		nightclub: "Antro",
		show: "Show",
		event: "Evento",
		festival: "Festival",
		beachClub: "Beach club",
		arena: "Arena",
		bistro: "Bistró",
	},
	linkSection: {
		title: "Enlaces externos (opcional)",
		site: "Sitio web",
		reservation: "Reservas",
		facebook: "Facebook",
		instagram: "Instagram",
		ticket: "Boletos",
		buttonHighlight: "Botón destacado (opcional)",
		pasteHere: "Pegue aquí",
	},
	addressSection: {
		title: "Información de dirección",
		titleOptional: "Información de dirección (opcional)",
		zigLocation: "Local Zig",
		zigLocationTooltip:
			"Es el polo de Zig donde su local fue registrado. Si desea cambiar, contacte a nuestro equipo",
		zipCode: "Código Postal",
		zipCodeLink: "No sé mi Código Postal",
		city: "Ciudad",
		state: "Estado",
		neighborhood: "Colonia",
		address: "Dirección",
		number: "Número",
		complement: "Complemento (opcional)",
		addressPlaceholder: "Nombre de la calle o avenida",
		complementPlaceholder: "Complemento de dirección",
	},
	operationSection: {
		placeTitle: "Horario de funcionamiento",
		eventTitle: "Fechas del evento",
		placeDescription:
			"Informe el día y horario de funcionamiento de su local. Si su local no funciona en algún día de la semana, simplemente no lo agregue en la lista de abajo.",
		eventDescription: "Informe el día y horario de funcionamiento de su evento.",
		day: "Día",
		add: "Agregar",
		date: "Fecha",
		time: "Hora (opcional)",
		until: "hasta",
		monday: "Lunes",
		tuesday: "Martes",
		wednesday: "Miércoles",
		thursday: "Jueves",
		friday: "Viernes",
		saturday: "Sábado",
		sunday: "Domingo",
	},
	appearsInAppModal: {
		title: "No compartir local en la aplicación",
		description:
			"Al desactivar, su local no se mostrará en la aplicación del usuario. ¿Desea continuar de todos modos?",
	},
	cancelEditModal: {
		title: "Cancelar edición",
		description:
			"Al cancelar la edición, las modificaciones no se guardarán. ¿Desea continuar de todos modos?",
	},
	successModal: {
		eventTitle: "¡La información fue guardada con éxito!",
		placeTitle: "¡La información fue guardada con éxito!",
		description: `Asegúrese que la función "Mostrar local en la aplicación del usuario" esté activa para que su local se muestre en Zig.app.`,
	},
	formValidations: {
		name: "Nombre es un campo obligatorio",
		nameMaxLength: "Límite máximo de caracteres es {{maxLength}}",
		locationCategory: "Categoría del local es un campo obligatorio",
		description: "Límite de 160 caracteres alcanzado",
		tags: "Solo puede seleccionar hasta 6 tags",
		musicTags: "Solo puede seleccionar hasta {{numberTags}} tags",
		link: "Ingrese un enlace válido",
		linkHighlightType: "Botón destacado es un campo obligatorio",
		zigLocation: "Local Zig es un campo obligatorio",
		postalCode: "Código Postal es un campo obligatorio",
		state: "Estado es un campo obligatorio",
		city: "Ciudad es un campo obligatorio",
		neighborhood: "Colonia es un campo obligatorio",
		streetName: "Dirección es un campo obligatorio",
		streetNumber: "Número es un campo obligatorio",
		image: "Imagen es obligatoria",
		imageSize: "Suba imágenes hasta 500kb",
		date: "Fecha es un campo obligatorio",
		generalError: "*Información obligatoria no llenada",
	},
};
